<div class="col-12" *ngIf="transport">
  <div class="row">
    <div class="col-auto">
      <i [class]="'icon ' + getTransportTypeIcon() + ' fa-3x'"></i>
    </div>
    <div class="col">
      <div class="row">
        <div class="col no-gutters">
          <jhi-bary-title [title]="'TRANSPORT.ID' | translate: { transportId: isTransportOrder ? transportOrder?.id : transportEstimation?.id }"></jhi-bary-title>
        </div>
        <div class="col-auto no-gutters">
          <p
            class="bold text-dark"
            *ngIf="
              transportEstimation &&
              transportEstimation.status === EstimationStatus.OK &&
              transportEstimation.estimation &&
              transportEstimation.estimation.gazoleTaxAmount &&
              transportEstimation.estimation.priceHT
            "
          >
            {{
              (isTransportOrder && transportOrder && transportOrder.priceHT && transportOrder.gazoleTax
                ? transportOrder.priceHT + transportOrder.gazoleTax
                : transportEstimation.estimation.priceHT + transportEstimation.estimation.gazoleTaxAmount
              ) | currency: 'EUR'
            }}
            {{ 'SUFFIX.PRE_TAXES' | translate }}
          </p>
          <p class="bold text-dark" *ngIf="transportEstimation?.status === EstimationStatus.QUOTATION">
            {{ (isTransportOrder ? transportOrder?.priceHT : transport.quotationBasePrice) | currency: 'EUR' }}
            {{ 'SUFFIX.PRE_TAXES' | translate }}
          </p>
          <p class="bold text-dark" *ngIf="transportEstimation?.status === EstimationStatus.ERROR"></p>
        </div>
      </div>
      <div class="alert alert-danger" *ngIf="transportEstimation?.status === EstimationStatus.ERROR">
        <span>{{ 'TRANSPORT_LINE.INVALID_TRANSPORT' | translate }}</span>
        <p *ngIf="isNotAQuotation()">{{ 'TRANSPORT_LINE.INVALID_TRANSPORT.DETAIL' | translate }}</p>
        <p *ngIf="!isNotAQuotation()">{{ 'TRANSPORT_LINE.INVALID_QUOTATION.DETAIL' | translate }}</p>
        <jhi-bary-collapse [label]="'TRANSPORT_LINE.INVALID_TRANSPORT.SHOW_MORE' | translate">
          <ul class="mb-0">
            <li *ngFor="let message of errorMessages">
              <small>{{ message }}</small>
            </li>
          </ul>
        </jhi-bary-collapse>
      </div>
      <div class="row" *ngIf="transport">
        <div class="col-12">
          <p
            class="mb-2"
            jhiTranslate="TRANSPORT_LINE.FROM_TO"
            [translateValues]="{
              pickupCity: transport.pickupAddressCity! | uppercase,
              pickupZipCode: transport.pickupAddressZipCode!,
              deliveryCity: transport.deliveryAddressCity! | uppercase,
              deliveryZipCode: transport.deliveryAddressZipCode!
            }"
          ></p>
        </div>
        <div class="col-12">
          <p
            jhiTranslate="TRANSPORT_LINE.PARAMS"
            [translateValues]="{
              pickupDate: transport.pickupDate?.toDate() | date: 'dd/MM/yyyy',
              pickupTimeslotStart: transport.pickupTimeslotStart,
              pickupTimeslotEnd: transport.pickupTimeslotEnd,
              transportConstraints: transport | transportConstraints: { pickup: true, inline: true } | lowercase
            }"
          ></p>
        </div>
      </div>
      <div class="row pt-2" *ngIf="transport">
        <div class="col-12 no-gutters" *ngIf="transport.goodsValue">
          <p class="bold text-success" jhiTranslate="TRANSPORT_LINE.INSURANCE" [translateValues]="{ goodsValue: transport.goodsValue | currency: 'EUR' }"></p>
        </div>
        <div class="col-12 no-gutters" *ngIf="!transport.goodsValue">
          <jhi-bary-title titleClass="bold text-dark mb-1" titleKey="TRANSPORT_LINE.NO_INSURANCE"></jhi-bary-title>
        </div>
        <div class="col-auto no-gutters" *ngIf="!transport.insuranceItem && !isPreview">
          <div class="alert alert-success color-success">
            <jhi-bary-icon icon="lightbulb" [faDirective]="FAR"></jhi-bary-icon>
            <span class="ml-1" jhiTranslate="TRANSPORT_LINE.ALERT.INSURE_TRANSPORT"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!isPreview && transport">
    <div class="col-12 no-gutters">
      <div class="row align-items-baseline">
        <div class="col">
          <jhi-bary-button *ngIf="!showDetail" [label]="'TRANSPORT_LINE.DETAILS.SHOW' | translate" [outline]="true" (clickEvent)="toggleDetails()"></jhi-bary-button>
          <jhi-bary-button *ngIf="showDetail" [label]="'TRANSPORT_LINE.DETAILS.HIDE' | translate" [outline]="true" (clickEvent)="toggleDetails()"></jhi-bary-button>
        </div>
        <div class="col-auto">
          <div class="d-inline-flex align-items-baseline">
            <jhi-bary-icon-button
              icon="pen"
              size="sm"
              color="secondary"
              (click)="handleEdit()"
              *ngIf="isNotAQuotation()"
              [tooltip]="'TRANSPORT_LINE.EDIT' | translate"
            ></jhi-bary-icon-button>
            <jhi-bary-specific-button type="trashButton" (click)="handleRemove()" [tooltip]="'TRANSPORT_LINE.DELETE' | translate"></jhi-bary-specific-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="stickerSubject">
    <div class="col-12 no-gutters">
      <div class="row align-items-baseline justify-content-end">
        <div class="col-12 col-md-auto">
          <jhi-bary-mailto
            *ngIf="!isBasket && transport && !isReturnPaymentDeffered"
            [emailTransporter]="documentEmailTransporter"
            [type]="transport.isHazardousMaterial ? LIST_MAILTO.ADD_DOCUMENT_ADR : LIST_MAILTO.ADD_DOCUMENT"
            labelkey="BTN.ATTACH_DOCUMENT"
            [params]="{ transportOrderView: transportOrder, transporterCompanyName: companyName, user: userMinimal }"
          >
          </jhi-bary-mailto>
        </div>
        <div class="col-12 col-md-auto" *ngIf="stickerSubject">
          <a [href]="PATHS.API_STICKER_VIEW.withId(transportOrder!.id)" [class.disabled]="!stickerSubject.isStopped" target="_blank">
            <jhi-bary-button
              [icon]="'barcode'"
              [outline]="true"
              [block]="true"
              [spinner]="stickerSubject"
              [spinnerLabel]="'TRANSPORT_LINE.STICKERS.SHOW' | translate"
              [label]="'TRANSPORT_LINE.STICKERS.SHOW' | translate"
            ></jhi-bary-button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid pt-3" *ngIf="showDetail && !isPreview">
    <div class="row pt-3">
      <div class="col-12 p-0">
        <jhi-transport-card [transport]="transport"></jhi-transport-card>
      </div>
    </div>
  </div>
</div>
